import qs from "qs"
import React, { useState, useEffect } from "react"
import filterIcon from "@/public/icons/filter.svg"
import downArrow from "@/public/icons/arrow-down.svg"
import closeIcon from "@/public/icons/close-dark-new.svg"
import MissingImage from "@/public/images/image-missing.png"
import warningIcon from "@/public/icons/warning.svg"
import Checkbox from "@/components/core/Checkbox/Checkbox"
import { apim } from "@/constants/api"
import { getCartItemType, pdpTypeFormat } from "@/utils/helper"
import { addDataLayer } from "./ProductDetailView/analytics"

const OrderSample = props => {
  const { showToaster, config } = props
  const [showMobileFilter, setMobileFilter] = useState(false)
  const [activeCol, setActiveCol] = useState([])
  const [colorList, setColorList] = useState([])
  const [total, setTotal] = useState(0)
  const [orderData, setOrderData] = useState([])
  const [showFilter, setShowFilter] = useState(true)
  const [sort, setSort] = useState("Sort By")
  const [showSortDrop, setShowSortDrop] = useState(false)
  const [quantity, setQuantity] = useState(0)
  const sortByVal = ["A - Z", "Z - A", "Price: High - Low", "Price: Low - High"]
  const [viewColorList, setViewColorList] = useState(false)
  const [hideColorList, setHideColorList] = useState(false)
  const [colorListDefault, setColorListDefault] = useState([])
  const [chkColorItems, setChkColorItems] = useState(false)
  const [sampleInfo, setSampleInfo] = useState([])
  const [scroll, setScroll] = useState(false)
  const [availableQuantity, setAvailableQuantity] = useState([])
  const divRef = React.useRef()
  const brandName = config.general?.brandName ?? ""
  const lwAppName = config.general?.lwAppName ?? ""
  let os = Object.values(props.orderSample)
  const enableaddtocart = props?.enableaddtocart
  const [enableAddToCart, setEnableAddToCart] = useState(enableaddtocart)
  let osData = props.orderSample[("SKUBadgeInfo_ss", "sampleSKUList_s")] === ""
  let SKU_S
  let SKU_SS
  if (osData) {
    SKU_SS = os[1].map(item => `"${item}"`).join(" OR ")
  } else {
    SKU_S = props.orderSample[("SKUBadgeInfo_ss", "sampleSKUList_s")]
  }
  let SKU_SID = osData ? SKU_SS : SKU_S

  let fl = [
    `productName_s`,
    `id`,
    `variantList.sku_s`,
    `variantList.sku_ss`,
    `productImages.url_s`,
    `productImages.url_ss`,
    `slug_s`,
    `ProductNewProduct_s`,
    `ProductExclusive_s`,
    `priceList.${props.persona}.finalPrice_d`,
    `priceList.${props.persona}.price_d`,
    `Color_Finish_Family`,
    `ProductDescriptionProductShort_s`,
    "Product_Category",
    `Color.SKU.Details_ss`,
    `category1_s`,
    `Super_Sku`,
    `ProductPriceSpiderIncluded_s`,
    `productRegionAllVariantDiscontinued_b`,
    `ProductProductRecommendedAccessories_ss`,
    `ProductBrandNameDisplay_t`,
    `priceList.${props.persona}.saleOffer_s`,
    `priceList.${props.persona}.discountedPrice_d`,
    `ProductExclusive_s`,
    `RegionReleaseforShipment_dt`,
    `RegionLaunchDate_dt`,
    `ProductBusinessUnit_ss`,
    `sku_s`,
    `productInStock_b`,
    `colorFinishFamilyList_ss`,
    `productDiscontinued_b`,
    `RegionSoldOnline_s`,
    `ProductPriceSpiderIncluded_s`,
    `ProductProductRecommendedAccessories_ss`,
  ]

  const onPageLoad = () => {
    apim
      .get(`search/plp`, {
        params: {
          q: "*:*",
          profilename: `profile_${lwAppName.toLowerCase()}_PLP`,
          collections: lwAppName.toLowerCase(),
          fq: `variantList.sku_s:(${SKU_SID}) OR variantList.sku_ss:("${SKU_SID}")`,
          fl: fl.join(","),
          rows: 20,
        },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: "repeat", encode: false })
        },
      })
      .then(res => {
        setOrderData(res.data.response.docs)
        setSampleAnalyticsInfo(res.data.response.docs)
        getColor(
          res.data?.facet_counts?.facet_fields["colorFinishFamilyList_ss"]
        )
      })
  }

  const inventoryStock = async () => {
    const skuValues = orderData.map(skus => skus.sku_s)
    try {
      const res = await apim.get(`catalog/inventory?sku=${skuValues.join(",")}`)
      const response = res.data.results ?? []
      setAvailableQuantity(response)
    } catch (err) {
      log.error("Fetching data failed", err)
    }
  }

  useEffect(() => {
    onPageLoad()
  }, [])

  useEffect(() => {
    inventoryStock()
  }, [orderData])

  const imageBoxToggler = (index, isActive) => {
    addDataLayer({
      title: (isActive ? "sample unselect" : "sample select").toLowerCase(),
      isSampleOverlay: true,
      productInfo: JSON.stringify(sampleInfo[index]),
    })
    let updatedArr = []
    let cardTotal = 0
    updatedArr = orderData.map(a => {
      if (
        orderData.indexOf(a) === index &&
        (a.index === null || a.index === undefined)
      ) {
        a.index = index
      }
      if (orderData.indexOf(a) === index && a.isActive === undefined) {
        return { ...a, isActive: true }
      } else if (orderData.indexOf(a) === index && a.isActive === false) {
        return { ...a, isActive: true }
      } else if (orderData.indexOf(a) !== index && a.isActive === true) {
        return { ...a, isActive: true }
      } else {
        return { ...a, isActive: false }
      }
    })

    cardTotal = updatedArr.reduce((acc, curr) => {
      if (curr.isActive) {
        return acc + curr[`priceList.${props.persona}.price_d`]
      }
      return acc
    }, 0)
    setTotal(cardTotal)
    setQuantity(
      updatedArr.filter(item => {
        return item.isActive
      }).length
    )
    return setOrderData(updatedArr)
  }

  const setSampleAnalyticsInfo = obj => {
    let infoObj = []
    obj.map(a => {
      const productInfo = {
        description: a.ProductDescriptionProductShort_s || "n/a",
        frequency: "n/a",
        globalPromotionPrice:
          a[`priceList.${props.persona}.finalPrice_d`] || "n/a",
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: "regular price",
        productBasePrice: a[`priceList.${props.persona}.finalPrice_d`] || "n/a",
        productCategory: a.Product_Category || "n/a",
        productColor: a.colorFinishFamilyList_ss[0] || "n/a",
        productCoupondiscount:
          a[`priceList.${props.persona}.discountedPrice_d`] || 0,
        productCouponCode: "n/a",
        productID: `${a["variantList.sku_ss"][0]}` || "n/a",
        productName: a.productName_s || "n/a",
        productPartnerBuyNow:
          a?.ProductPriceSpiderIncluded_s ||
          a?.productDiscontinued_b ||
          a?.RegionSoldOnline_s === "false"
            ? a?.ProductPriceSpiderIncluded_s
              ? true
              : false
            : false,
        productRoom: a.category1_s || "n/a",
        productSalePrice: a[`priceList.${props.persona}.discountedPrice_d`]
          ? a[`priceList.${props.persona}.discountedPrice_d`]
          : a[`priceList.${props.persona}.finalPrice_d`],
        productSaleable:
          a?.productDiscontinued_b || a?.RegionSoldOnline_s === "false"
            ? false
            : true,
        productStatus: "later",
        productSuperSku: a?.Super_Sku ? true : false,
        productTileName: a.productName_s,
        quantity: 1,
        defaultImageName:
          a["productImages.url_ss"] === undefined
            ? MissingImage
            : a["productImages.url_ss"],
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: pdpTypeFormat({
          businessUnitName: a.category1_s,
          ProductPriceSpiderIncluded_s: a?.ProductPriceSpiderIncluded_s,
          discontinuedProductb: a.productDiscontinued_b,
          ProductRequiredAccessoriesGroupsList:
            a?.ProductProductRecommendedAccessories_ss
              ? a?.ProductProductRecommendedAccessories_ss
              : [],
          superSku: a?.Super_Sku ? true : false,
        }),
        productFindingMethod: "n/a",
        productCollectionsName: a.Product_Category || "n/a",
        productBrand: config.general?.siteName?.toLowerCase(),
        globalOffer: a[`priceList.${props.persona}.saleOffer_s`] || "n/a",
        globalDiscount: a[`priceList.${props.persona}.discountedPrice_d`]
          ? a[`priceList.${props.persona}.discountedPrice_d`]
          : 0,
        itemType: getCartItemType(a.Product_Category, a.category1_s),
      }
      infoObj.push(productInfo)
    })
    setSampleInfo(infoObj)
  }

  const sortHandler = val => {
    addDataLayer({
      title: val.toLowerCase(),
      isSampleOverlay: true,
      isSort: true,
    })
    setSort(val)
    switch (val) {
      case "A - Z":
        return orderData.sort((a, b) =>
          a.productName_s < b.productName_s ? -1 : 0
        )
      case "Z - A":
        return orderData.sort((a, b) =>
          a.productName_s > b.productName_s ? -1 : 0
        )
      case "Price: High - Low":
        return orderData.sort((a, b) =>
          a[`priceList.${props.persona}.price_d`] >
          b[`priceList.${props.persona}.price_d`]
            ? -1
            : 0
        )
      case "Price: Low - High":
        return orderData.sort((a, b) =>
          a[`priceList.${props.persona}.price_d`] <
          b[`priceList.${props.persona}.price_d`]
            ? -1
            : 0
        )
      default:
        return false
    }
  }
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 767) setShowFilter(true)
      else setShowFilter(false)
    }
    window.addEventListener("resize", handleResize)
    handleResize()
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const filterHandler = () => {
    addDataLayer({
      title: (showFilter ? "Hide Filters" : "Show Filters").toLowerCase(),
      isSampleOverlay: true,
      filterProps: {
        isFilter: true,
      },
    })
    return setShowFilter(!showFilter)
  }

  const mobileFilterHandler = () => {
    setMobileFilter(!showMobileFilter)
  }

  const sortToggle = () => {
    setShowSortDrop(!showSortDrop)
  }
  const filterText = showFilter ? "Hide Filter" : "Show Filter"

  const getAppliedColorsForAnalytics = appliedColors => {
    let filterArray = []
    appliedColors.forEach(color => {
      color.isActive && filterArray.push(`color:${color.name.toLowerCase()}`)
    })
    return filterArray.length ? filterArray.join("|") : ""
  }

  const onColorHandler = (index, activeCol, colorName) => {
    let updateCol = []
    let atCol = []
    updateCol = colorList.map(b => {
      if (colorList.indexOf(b) === index && b.isActive === undefined) {
        return { ...b, isActive: true }
      } else if (colorList.indexOf(b) === index && b.isActive === false) {
        return { ...b, isActive: true }
      } else if (colorList.indexOf(b) !== index && b.isActive === true) {
        return { ...b, isActive: true }
      } else {
        return { ...b, isActive: false }
      }
    })
    atCol = updateCol.filter(a => {
      return a.isActive === true
    })
    let x = updateCol.map(item => {
      let a = ""
      if (item.isActive === true) {
        a += item.name
      }
      return a
    })
    let d = x
      .filter(c => `${c}`)
      .map(e => `"${e}"`)
      .join(" OR ")
    d ? onFiterChange(d) : onPageLoad()

    atCol?.length > 0 ? setChkColorItems(true) : setChkColorItems(false)
    setColorList(updateCol)
    setActiveCol(atCol)
    addDataLayer({
      title: !activeCol ? "filter applied" : "filter removed",
      isSampleOverlay: true,
      filterProps: {
        isFilter: true,
        appliedFilters: getAppliedColorsForAnalytics(atCol),
        filterName: colorName.toLowerCase(),
      },
    })
  }
  // on Filter change API call
  const onFiterChange = d => {
    apim
      .get(`search/plp`, {
        params: {
          q: "*:*",
          profilename: `profile_${lwAppName.toLowerCase()}_PLP`,
          collections: lwAppName.toLowerCase(),
          fq: [
            `variantList.sku_s:(${SKU_SID}) OR variantList.sku_ss:("${SKU_SID}")`,
            `{!tag="colorFinishFamilyList_ss"}colorFinishFamilyList_ss:(${d})`,
          ],
          fl: fl.join(","),
          rows: 20,
        },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: "repeat", encode: false })
        },
      })
      .then(res => setOrderData(res.data.response.docs))
  }

  const getColor = arr => {
    let colObj = []
    for (let i = 0; i < arr.length; i = i + 2) {
      colObj.push({ name: arr[i], count: arr[i + 1] })
    }
    const size = colObj?.length > 3 ? 3 : colObj?.length
    if (colObj?.length > size) setViewColorList(true)
    handleColorsList(size, colObj)
    return setColorListDefault(colObj)
  }

  const handleColorsList = (size, colorDetails) => {
    if (colorDetails?.length > 0) {
      let list = []
      colorDetails.map((item, i) => {
        if (i < size) list.push(item)
      })
      setColorList(list)
    }
  }

  const handleOrderSampleListView = (show, title) => {
    addDataLayer({
      title: title.toLowerCase(),
      isSampleOverlay: true,
      filterProps: {
        isFilter: true,
      },
    })
    if (show) {
      handleColorsList(Number(colorListDefault?.length), colorListDefault)
      setViewColorList(false)
      setHideColorList(true)
    } else {
      handleColorsList(3, colorListDefault)
      setHideColorList(false)
      setViewColorList(true)
    }
  }

  //Remove filter item
  const removeCol = val => {
    let arrC = []
    let arrD = []
    arrC = activeCol.map(item => {
      if (item.name === val && item.isActive) {
        return { ...item, isActive: false }
      } else if (item.name !== val && !item.isActive) {
        return { ...item, isActive: false }
      } else if (item.name !== val && item.isActive) {
        return { ...item, isActive: true }
      } else {
        return { ...item, isActive: false }
      }
    })

    arrD = colorList.map(col => {
      if (col.name === val && col.isActive) {
        return { ...col, isActive: false }
      } else if (col.name !== val && !col.isActive) {
        return { ...col, isActive: false }
      } else if (col.name !== val && col.isActive) {
        return { ...col, isActive: true }
      } else {
        return { ...col, isActive: false }
      }
    })

    let x = arrC.map(item => {
      let a = ""
      if (item.isActive === true) {
        a += item.name
      }
      return a
    })

    let hideClearAll = false
    if (arrC !== undefined && arrC.length > 0) {
      for (let k = 0; k < arrC.length; k = k + 1) {
        if (arrC[k]["isActive"] === true) {
          hideClearAll = true
        }
      }
    }
    hideClearAll ? setChkColorItems(true) : setChkColorItems(false)
    let d = x
      .filter(c => `${c}`)
      .map(e => `"${e}"`)
      .join(" OR ")
    d ? onFiterChange(d) : onPageLoad()
    setActiveCol(arrC)
    setColorList(arrD)
    addDataLayer({
      title: "filter cancel",
      isSampleOverlay: true,
      filterProps: {
        isFilter: true,
        appliedFilters: getAppliedColorsForAnalytics(arrC),
        filterName: val.toLowerCase(),
      },
    })
  }

  const clearAllCol = () => {
    let clerarCol = []
    let clerar = colorList.map(item => {
      return { ...item, isActive: false }
    })
    setChkColorItems(false)
    setActiveCol(clerarCol)
    setColorList(clerar)
    addDataLayer({
      title: props?.staticTexts?.clearAll.toLowerCase(),
      isSampleOverlay: true,
      filterProps: {
        isFilter: true,
      },
    })
    onPageLoad()
  }

  const selectedAnalyticsData = data => {
    let itemAnalyticsArray = []
    data.map(obj => {
      itemAnalyticsArray.push({
        productInfo: sampleInfo[obj.index],
        quantity: sampleInfo[obj.index].quantity,
      })
    })
    return itemAnalyticsArray
  }

  const handleAddToCart = () => {
    const selectedData = orderData.filter(item => {
      return item.isActive
    })
    const itemAnalyticsArray = selectedAnalyticsData(selectedData)
    let chartItems = []
    selectedData.map(item => {
      let Vskus = item["variantList.sku_s"]
        ? item["variantList.sku_s"]
        : item["variantList.sku_ss"]?.length > 0
        ? item["variantList.sku_ss"][0]
        : ""
      if (Vskus) {
        chartItems.push({
          sku: Vskus,
          quantity: 1,
          brand: brandName.toLowerCase(),
        })
      }
    })
    props.onAddToCart(chartItems, params => {
      addDataLayer({
        title: (props?.staticTexts?.addToCart).toLowerCase(),
        isSampleOverlay: true,
        isAddtoCart: true,
        cartData: params.data,
        productArray: JSON.stringify({ item: itemAnalyticsArray }),
      })
    })
    props.closePopup()
    showToaster(selectedData)
  }

  const handleCloseOverlay = () => {
    props.closePopup()
    addDataLayer({
      title: "close",
      isSampleOverlay: true,
    })
  }
  const closeSortOn = () => {
    if (showSortDrop) {
      setShowSortDrop(false)
    }
  }
  const handleScroll = e => {
    const scrolledFromTop = divRef.current.scrollTop
    setScroll(scrolledFromTop > 10)
  }

  return (
    <div className="orderOverlay" onScroll={handleScroll} ref={divRef}>
      <div className="orderSampleWrapper" onClick={closeSortOn}>
        <div className="order-sample-container">
          <button onClick={handleCloseOverlay} className="closeBtn">
            <img
              onError={e => (e.target.src = MissingImage?.src)}
              src={closeIcon?.src}
            />
          </button>
          <div className="osHeader">
            <h1>
              {props.productSummaryData["ProductBrandName_s"]
                ? props.productSummaryData["ProductBrandName_s"]
                : props.staticTexts.orderASample}
            </h1>
            <p>
              {props.productSummaryData["ProductDescriptionSmall_s"]
                ? props.productSummaryData["ProductDescriptionSmall_s"]
                : ""}
            </p>
            <div className="optionWrapper">
              <h5>{props?.staticTexts?.color}</h5>
              <span> {`${orderData.length} options`}</span>
            </div>
          </div>
          <div
            className={`order-sample-wrapper ${
              scroll ? "filterStickyHeader" : ""
            }`}
          >
            <div className="stickyHeader">
              <button className="filter" onClick={filterHandler}>
                <img
                  onError={e => (e.target.src = MissingImage?.src)}
                  src={filterIcon}
                />
                <span>{`${filterText} ${
                  activeCol.length > 0 ? `(${activeCol.length})` : ``
                }`}</span>
              </button>
              <button className="filterMobile" onClick={mobileFilterHandler}>
                <img
                  onError={e => (e.target.src = MissingImage?.src)}
                  src={filterIcon}
                />
                <span>{`${props?.staticTexts?.filter} ${
                  activeCol.length > 0 ? `(${activeCol.length})` : ``
                }`}</span>
              </button>
              <div className="sortWrapper" onClick={sortToggle}>
                <button className="sort">
                  {sort}{" "}
                  <img
                    onError={e => (e.target.src = MissingImage?.src)}
                    className={showSortDrop ? "upArro" : "downArro"}
                    src={downArrow}
                  />
                </button>
                {showSortDrop && (
                  <ul className="sortList">
                    {sortByVal.map((item, key) => {
                      return (
                        <li
                          key={"sortList_" + key}
                          onClick={() => sortHandler(item)}
                        >
                          {item}
                        </li>
                      )
                    })}
                  </ul>
                )}
              </div>
            </div>
          </div>
          <div className="mainWrapper">
            {showFilter && (
              <div className="filterWrapper">
                <div className="activeColor">
                  {activeCol.length > 0 &&
                    activeCol.map(item => {
                      return (
                        item.isActive && (
                          <button
                            value={item.name}
                            onClick={() => removeCol(item.name)}
                          >
                            <span>{`${item.name}`}</span>
                            <span>
                              <img
                                onError={e =>
                                  (e.target.src = MissingImage?.src)
                                }
                                src={closeIcon}
                              />
                            </span>
                          </button>
                        )
                      )
                    })}
                </div>
                {chkColorItems === true && (
                  <button className="clearAll" onClick={clearAllCol}>
                    {props?.staticTexts?.clearAll}
                  </button>
                )}
                <ul>
                  {colorList.length > 0 &&
                    colorList.map((col, index) => {
                      return (
                        <li
                          key={"checkboxWrapper_" + index}
                          className="checkboxWrapper"
                        >
                          <Checkbox
                            value={`${col.name} (${col.count})`}
                            onChange={() =>
                              onColorHandler(index, col.isActive, col.name)
                            }
                            checked={col.isActive}
                          />
                        </li>
                      )
                    })}
                </ul>
                {viewColorList && (
                  <div
                    className="orderSampleWrapper__view_more"
                    onClick={() =>
                      handleOrderSampleListView(
                        true,
                        props?.staticTexts?.sampleViewMore
                      )
                    }
                  >
                    {props?.staticTexts?.sampleViewMore}
                  </div>
                )}
                {hideColorList && (
                  <div
                    className="orderSampleWrapper__view_more"
                    onClick={() =>
                      handleOrderSampleListView(
                        false,
                        props?.staticTexts?.sampleViewLess
                      )
                    }
                  >
                    {props?.staticTexts?.sampleViewLess}
                  </div>
                )}
              </div>
            )}

            {showMobileFilter && (
              <div className="filterWrapperMobile">
                <div className="mobileFilterHead">
                  <button
                    className="filterMobile"
                    onClick={mobileFilterHandler}
                  >
                    <img
                      onError={e => (e.target.src = MissingImage?.src)}
                      src={filterIcon}
                    />
                    <span>{`${props?.staticTexts?.filter} ${
                      activeCol.length > 0 ? `(${activeCol.length})` : ``
                    }`}</span>
                  </button>
                  <button
                    onClick={mobileFilterHandler}
                    className="mobleCloseBtn"
                  >
                    <img
                      onError={e => (e.target.src = MissingImage?.src)}
                      src={closeIcon}
                    />
                  </button>
                </div>
                <div className="activeColor">
                  {activeCol.length > 0 &&
                    activeCol.map((item, index) => {
                      return (
                        item.isActive && (
                          <button
                            key={"activeColor" + index}
                            value={item.name}
                            onClick={() => removeCol(item.name)}
                          >{`${item.name} X`}</button>
                        )
                      )
                    })}
                </div>
                {chkColorItems === true && (
                  <button className="clearAll" onClick={clearAllCol}>
                    {props?.staticTexts?.clearAll}
                  </button>
                )}
                <div className="mob-colorlist-filter">
                  <ul
                    className={
                      chkColorItems === true ? "clearcolor-availability" : ""
                    }
                  >
                    {colorList.map((col, index) => {
                      return (
                        <li
                          key={"checkboxWrapper2_" + index}
                          className="checkboxWrapper"
                        >
                          <Checkbox
                            value={col.name}
                            count={col.count}
                            onChange={() =>
                              onColorHandler(index, col.isActive, col.name)
                            }
                            checked={col.isActive}
                          />
                        </li>
                      )
                    })}
                  </ul>
                  {viewColorList && (
                    <div
                      className="orderSampleWrapper__view_more"
                      onClick={() =>
                        handleOrderSampleListView(
                          true,
                          props?.staticTexts?.sampleViewMore
                        )
                      }
                    >
                      {props?.staticTexts?.sampleViewMore}
                    </div>
                  )}
                  {hideColorList && (
                    <div
                      className="orderSampleWrapper__view_more"
                      onClick={() =>
                        handleOrderSampleListView(
                          false,
                          props?.staticTexts?.sampleViewLess
                        )
                      }
                    >
                      {props?.staticTexts?.sampleViewLess}
                    </div>
                  )}
                </div>
                <div className="filterFooter">
                  <button className="applyBtn" onClick={mobileFilterHandler}>
                    {props?.staticTexts?.apply}
                  </button>
                </div>
              </div>
            )}

            <div className="listWrapper">
              {orderData.length > 0 &&
                orderData.map((item, index) => {
                  let qtyCheck = availableQuantity.find(
                    qty => qty.sku === item.sku_s
                  )?.availableQuantity
                  return (
                    <div
                      className={
                        qtyCheck > 0 ? "cardWrapper" : "cardWrapper disabled"
                      }
                      key={item.id}
                    >
                      <div
                        className={`imgBox ${
                          item.isActive === true ? "active" : ""
                        }`}
                        onClick={() => imageBoxToggler(index, item.isActive)}
                      >
                        <span className="tag">
                          {props?.staticTexts?.newLabel}
                        </span>
                        <img
                          onError={e => (e.target.src = MissingImage?.src)}
                          src={
                            item["productImages.url_ss"] === undefined
                              ? MissingImage?.src
                              : item["productImages.url_ss"]
                          }
                        />
                      </div>
                      <div className="cardFooter">
                        <div className="cardTitle">{item.productName_s}</div>
                        <div>{`$${item[
                          `priceList.${props.persona}.price_d`
                        ]?.toFixed(2)}`}</div>
                      </div>
                      <>
                        {qtyCheck > 0 ? null : (
                          <>
                            <div className="out_of_stock">
                              <span className="icon">
                                <img
                                  src={warningIcon?.src}
                                  alt={props.staticTexts.outOfStockInfo}
                                />
                              </span>
                              <span className="text">
                                {props.staticTexts.outOfStockInfo}
                              </span>
                            </div>
                          </>
                        )}
                      </>
                    </div>
                  )
                })}
            </div>
          </div>
          {enableAddToCart && (
            <div className="orderFooter">
              <div className="addToCartWrapper">
                <div className="priceWrapper">
                  <span>{props?.staticTexts?.subtotal}</span>
                  <span className="cartPrice">{`$${
                    total ? total.toFixed(2) : 0.0
                  }`}</span>
                </div>
                <button
                  className={
                    quantity > 0 ? "addToCartBtn" : "addToCartBtn disabled"
                  }
                  onClick={handleAddToCart}
                >
                  {props?.staticTexts?.addToCart}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default OrderSample
